// extracted by mini-css-extract-plugin
export default {"content":"access-restricted_content__9Frlk"};